import { call, put, select } from 'redux-saga/effects';
import PartsActions from '../redux/partsRedux';
import { has } from '../services/helper';

const listPartsSaga = function* listEngines(api, action) {
    const locale = yield select(state => state.locale);
    const response = yield call(api.listParts, action.category, action.identifier, locale);
    const parts = has(response, 'data') ? response.data : null;
    if (response.ok) {
        yield put(PartsActions.listPartsSuccess(action.category, parts));
    } else {
        yield put(PartsActions.listPartsFailure());
    }
};

const resetPartsSaga = function* resetParts(action) {
    if (action.refresh) {
        yield put(PartsActions.refreshParts());
    }
};

export { listPartsSaga, resetPartsSaga };
